import { Box, Grid, Tab, Tabs, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import * as React from "react";
import useJobList from "../../hooks/useJobsList";
import Addjob from "../Jobs/AddJob";
import Job from "../Jobs/Job";
import Loader from "../Loader";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Jobs() {
  const [value, setValue] = React.useState(0);
  const { loading, error, jobs } = useJobList();
  const [homeJobs, setHomeJobs] = React.useState([]);
  const [forYourJobs, setForYouJobs] = React.useState([]);
  const [newJobs, setNewJobs] = React.useState([]);
  const [trendingJobs, setTrendingJobs] = React.useState([]);

  React.useEffect(() => {
    let hJ = [];
    let fJ = [];
    let tJ = [];
    let nJ = [];

    jobs.map((job) => {
      if (job?.jobFor == "1") {
        hJ.push(job);
      } else if (job?.jobFor == "2") {
        fJ.push(job);
      } else if (job?.jobFor == "3") {
        nJ.push(job);
      } else if (job?.jobFor == "4") {
        tJ.push(job);
      }
    });

    setForYouJobs(fJ);
    setTrendingJobs(tJ);
    setNewJobs(nJ);
    setHomeJobs(hJ);
  }, [jobs]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (loading) {
    return <Loader loading={loading} />;
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Add Job" {...a11yProps(0)} />
          <Tab label="Home" {...a11yProps(1)} />
          <Tab label="For You" {...a11yProps(2)} />
          <Tab label="New Job" {...a11yProps(3)} />
          <Tab label="Trending Job" {...a11yProps(4)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Addjob />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Grid container spacing={5}>
          {homeJobs?.map((cs) => (
            <Grid item xs={12} sm={12} md={6}>
              <Job job={cs} />
            </Grid>
          ))}
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Grid container spacing={5}>
          {forYourJobs?.map((cs) => (
            <Grid item xs={12} sm={12} md={6}>
              <Job job={cs} />
            </Grid>
          ))}
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Grid container spacing={5}>
          {newJobs?.map((cs) => (
            <Grid item xs={12} sm={12} md={6}>
              <Job job={cs} />
            </Grid>
          ))}
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Grid container spacing={5}>
          {trendingJobs?.map((cs) => (
            <Grid item xs={12} sm={12} md={6}>
              <Job job={cs} />
            </Grid>
          ))}
        </Grid>
      </TabPanel>
    </Box>
  );
}
